import React, { useState } from 'react';
import EditDialog from '../../../../../components/Dialog/Ok';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import axios from '../../../../../api/axios';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  stateEditForm: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const EditState = ({ data, onClose }) => {
  const classes = useStyles();
  const [state, setState] = useState(data);
  const handleTic = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setState({ ...state, directions: [...state.directions, value] });
    } else {
      setState({
        ...state,
        directions: [...state.directions.filter((d) => d !== value)],
      });
    }
  };
  const handleSave = async () => {
    try {
      await axios.put(`/api/v1/admin/state/${state._id}`, {
        directions: state.directions,
      });
    } catch (error) {}
    onClose();
  };

  return (
    <EditDialog
      ok="ذخیره"
      title={`ویرایش استان ${state.title}`}
      onClose={handleSave}
      fullWidth
    >
      <div className={classes.stateEditForm}>
        <div>محل قرارگیری استان را انتخاب کنید:</div>
        <FormControlLabel
          control={
            <Checkbox
              checked={state.directions.includes('شمال')}
              onChange={handleTic}
              value="شمال"
            />
          }
          label="شمال"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleTic}
              checked={state.directions.includes('شرق')}
              value="شرق"
            />
          }
          label="شرق"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleTic}
              checked={state.directions.includes('جنوب')}
              value="جنوب"
            />
          }
          label="جنوب"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleTic}
              checked={state.directions.includes('غرب')}
              value="غرب"
            />
          }
          label="غرب"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleTic}
              checked={state.directions.includes('مرکز')}
              value="مرکز"
            />
          }
          label="مرکز"
        />
      </div>
    </EditDialog>
  );
};

export default EditState;
